export default __webpack_public_path__ + "static/icon-9-4-997f15722609eecf10daf345e73469c2.png";